<prism-dialog id="sh-cookie-dialog" [visible]="true" confirm-button="" cancel-button="" *transloco="let t">
	<span slot="dialog-title" id="sh-cookie-dialog-title-h1">{{
		t('cloud.shared.cookie-dialog.cookies-are-required')
	}}</span>

	<div id="sh-cookie-dialog-description-div">
		{{ t('cloud.shared.cookie-dialog.cookies-are-disabled-description') }}
	</div>
</prism-dialog>
